import { useState, useEffect, useCallback } from "react"
import AccordionWrapper from './components/accordion'
import Loading from "components/center-loading"
import Filtro from "components/filters/filter-estoque-fornecedor"
import { useGlobalContext } from 'hooks/useGlobalContext';
import intl from "react-intl-universal"
import * as S from "./styled"
import { buscaEstoqueCompartilhado, getDownloadSupplierStock, getDownloadSupplierStockModel, salvarAnotacoes, salvarMateriaisPorFornecedor } from './estoque-fornecedor.service'
import { separaListaColunaItem, retornaPosicaoPorIdFornecedor, validaExibicaoMensagemErroFornecedor, showAnnotations, supplierStockFilterDefault } from "./utils"
import IconEmpty from "images/iconEmpty.icon"
import Session from "utils/user-storage"
import ImportExport from "../../components/import-export"
import { downloadFile, verifyIsFiltered } from "../../utils/custom-functions"
import moment from "moment"
import { userFornecedor } from "../../services/permissions/getPermissions"
import StorePersist from "utils/store-persist"
import IconCalendarScheduleRefresh from "components/icons/icn-calendar-refresh.icon"
import { formatErrorMessage } from "utils/handle-error"
import TextArea from "components/textarea"
import Sidebar from "components/sidebar"
import ButtonIcon from "components/button-icon"
import { IconFilterActive } from "components/icons/icn-filter-active.icon"
import { IconFilterInactive } from "components/icons/icn-filter-inactive.icon"
import Button from "components/button";
import { Redirect } from "react-router-dom";
import {
  getSupplierStockConsolidatedExperienceEnabled,
  getSupplierStockDecommissionAt,
} from "utils/config-environment";
import { getSupplierStockTransitionState, supplierStockTransitionStates } from "utils/supplier-stock-transition";
import SupplierStockTransitionBanner from "./components/supplier-stock-transition-banner";

const EstoqueFornecedor = () => {
  const decommissionAt = getSupplierStockDecommissionAt()
  const transitionState = getSupplierStockTransitionState({
    consolidatedExperienceEnabled: getSupplierStockConsolidatedExperienceEnabled(),
    decommissionAt,
  })
  const isTransitionActive = transitionState === supplierStockTransitionStates.active
  const [fornecedores, setFornecedores] = useState(undefined)
  const [carregou, setCarregou] = useState(null)
  const [anotacoes, setAnotacoes] = useState('')
  const [fetching, setFetching] = useState(false)
  const [mostrarFiltro, setMostrarFiltro] = useState(false)
  const [filtros, setFiltros] = useState(supplierStockFilterDefault)
  const [mensagemUsuario, setMensagemUsuario] = useState(false)
  const [importExportSupplierStock, setImportExportSupplierStock] = useState(false)
  const { showFeedback } = useGlobalContext();

  const estoqueCompartilhado = useCallback(async () => {
    setFetching(true)
    if (Session.get().TipoUsuario === 1 && !verifyIsFiltered(filtros)) {
      setMensagemUsuario(true)
      setCarregou(true)
    } else {
      const f = await buscaEstoqueCompartilhado()
      setCarregou(f.IsLoad)
      setFornecedores(separaListaColunaItem(f))
      setAnotacoes(f.Notes)
      setMensagemUsuario(false)
    }
    setFetching(false)
  }, [])

  const mudaValorAnotacao = (event) => {
    setAnotacoes(event.target.value)
  }

  const salvaAnotacoes = async () => {
    try {
      await salvarAnotacoes({ Notes: anotacoes })
      showFeedback(intl.get("stocks.timeline.feedback.notesSavedSuccessfully"))
    } catch (error) {
      showFeedback(formatErrorMessage(error))
    }
  }

  const modificaValorInput = (values, IdFornecedor, i, coluna) => {
    const step = { ...fornecedores }
    const fornecedor = fornecedores && fornecedores[coluna]
    const posicaoFornecedor = retornaPosicaoPorIdFornecedor(IdFornecedor, fornecedor)
    const posicaoMaterial = i
    step[coluna][posicaoFornecedor].Materials[posicaoMaterial].Quantity = values
    setFornecedores({ ...step })
  }

  const salvar = async (IdFornecedor, event, posicao, coluna) => {
    event.stopPropagation()

    const step = { ...fornecedores }
    const posicaoFornecedor = posicao

    step[coluna][posicaoFornecedor].Salvando = !step[coluna][posicaoFornecedor].Salvando
    setFornecedores({ ...step })

    const materiaisParaSalvar = step[coluna][posicaoFornecedor].Materials
    await salvarMateriaisPorFornecedor(IdFornecedor, materiaisParaSalvar)

    step[coluna][posicaoFornecedor].Salvando = !step[coluna][posicaoFornecedor].Salvando
    setFornecedores({ ...step })
  }

  const filtrar = async (filtro, showFilter = !mostrarFiltro) => {
    setFetching(true)
    setFornecedores(undefined)

    if (Session.get().TipoUsuario === 1 && !verifyIsFiltered(filtro)) {
      setFornecedores(undefined)
      setMensagemUsuario(true)
    } else {
      const f = await buscaEstoqueCompartilhado(filtro)
      setCarregou(f.IsLoad)
      setFornecedores(separaListaColunaItem(f))
      setMensagemUsuario(false)
      setAnotacoes(f.Notes)
    }
    setMostrarFiltro(showFilter)
    setFiltros(filtro)
    StorePersist.setValuesJSON("filtersSupplierStockMulti", filtro);
    setFetching(false)
  }

  const atualizarFiltro = (estado) => {
    setMostrarFiltro(estado)
  }

  const openSupplierStockImportExport = () => {
    setImportExportSupplierStock(prevState => !prevState)
  }

  const downloadSupplierStock = async () => {
    try {
      const data = await getDownloadSupplierStock();
      const datafile = moment(new Date()).format('YYYYMMDD_HHmmss')
      downloadFile(`${datafile}_EstoqueFornecedor.csv`, 'csv', data)
    } catch (err) {
      console.log(err)
    }
  }

  const downloadSupplierStockModel = async () => {
    try {
      const data = await getDownloadSupplierStockModel();
      const datafile = moment(new Date()).format('YYYYMMDD_HHmmss')
      downloadFile(`${datafile}_ModeloEstoqueFornecedor.csv`, 'csv', data)
    } catch (err) {
      console.log(err)
    }
  }

  const getFilterIcon = () => {
    if(localStorage.getItem("THEME") != 1 ){
      if(verifyIsFiltered(filtros))
        return <IconFilterActive />;
      else 
        return <IconFilterInactive />;
    }else
      return undefined;
  }

  useEffect(() => {
    if (transitionState === supplierStockTransitionStates.expired) {
      return
    }
    estoqueCompartilhado()
    const _filters = StorePersist.getValuesJSON("filtersSupplierStockMulti");
    if(_filters !== filtros) {
      filtrar(_filters, false);
    }
  }, [])

  if (transitionState === supplierStockTransitionStates.expired) {
    return <Redirect to="/production-plan-supplier" />
  }


  return (
    <S.EstoqueFornecedorWrapper>
      <S.EstoqueFornecedorHeader title={intl.get("menu.subMenuGeneral.supplierStock")}>
        <div style={{ display: 'flex', justifyContent: 'flex-end', width: "100%", alignItems: "center" }}>
          {
            userFornecedor() &&
            <div
              title={intl.get("exportImportModal.supplierStock.title")}
              className="button-actions">
              <ButtonIcon
                onClick={() => openSupplierStockImportExport()}
                buttonType="secondary"
                buttonIcon={<IconCalendarScheduleRefresh />}
              />
            </div>
          }
          <ButtonIcon
            onClick={() => atualizarFiltro(true)}
            buttonType='secondary'
            buttonText={intl.get('filters.filter')}
            className='button-filter'
            buttonIcon={getFilterIcon()}
          />
        </div>
        <Sidebar
          visible={mostrarFiltro}
          triggerClose={() => atualizarFiltro(false)}
          icon={IconEmpty}
        >
          <Filtro emitter={filtrar} />
        </Sidebar>
      </S.EstoqueFornecedorHeader>
      {isTransitionActive && <SupplierStockTransitionBanner decommissionAt={decommissionAt} />}
      <S.EstoqueFornecedorContent espacamento="1rem">
        {
          (validaExibicaoMensagemErroFornecedor(fornecedores)) &&
          <div className="errorMessage">{intl.get("commons.noRecordsFound")}</div>
        }
        <S.EstoqueFornecedorFirstAccordion>
          {
            mensagemUsuario &&
            <div className="errorMessage__user">
              {intl.get("supplierStock.message")}
            </div>
          }
          {fornecedores &&
            <AccordionWrapper
              dados={fornecedores.primeira}
              coluna={'primeira'}
              salvar={salvar}
              valorInput={modificaValorInput}
              editingDisabled={isTransitionActive}
            />
          }
        </S.EstoqueFornecedorFirstAccordion>
        <S.EstoqueFornecedorSecondAccordion>
          {fornecedores &&
            <AccordionWrapper
              dados={fornecedores.segunda}
              coluna={'segunda'}
              salvar={salvar}
              valorInput={modificaValorInput}
              editingDisabled={isTransitionActive}
            />
          }
        </S.EstoqueFornecedorSecondAccordion>
      </S.EstoqueFornecedorContent>
      <div>
        <Loading isLoading={fetching} />
        {
          showAnnotations(fornecedores) && carregou &&
          <div>
            <S.EstoqueFornecedorActionsWrapper>
              <div className="notes-wrapper">
                <TextArea
                  data-testid="anotacoes"
                  label={intl.get("stocks.stockDetail.annotations")} 
                  rows={4} 
                  value={anotacoes}
                  onChange={(event) => mudaValorAnotacao(event)}
                />
              </div>
            </S.EstoqueFornecedorActionsWrapper>
            <S.EstoqueFornecedorActionsWrapper>
              <div className="button-wrapper">
                <Button
                  buttonType="primary"
                  value={intl.get("stocks.stockDetail.saveAnnotations")}
                  onClick={() => salvaAnotacoes()}
                  style={{ width: '150px' }}
                />
              </div>
            </S.EstoqueFornecedorActionsWrapper>
          </div>
        }
      </div>
      <ImportExport
        title={intl.get("exportImportModal.supplierStock.title")}
        contextModal="supplierStock"
        open={importExportSupplierStock}
        handleClose={openSupplierStockImportExport}
        downloadArquivo={downloadSupplierStock}
        downloadModelo={downloadSupplierStockModel}
        importArquivo="supplierStock/import"
        type='csv'
        hideImport={isTransitionActive}
      />
    </S.EstoqueFornecedorWrapper>
  )
}

export default EstoqueFornecedor
